import RecapProductList from 'components/Content/Recap/RecapProductList/RecapProductList';
import { withRecapProductListJustArrivedProps } from 'components/Content/Recap/RecapProductListJustArrived/withRecapProductListJustArrivedProps';

export default withRecapProductListJustArrivedProps(RecapProductList);
